module.exports = __webpack_public_path__ + "img/foto4.a323c274.jpg";